import { useState } from "react";
import { Button, Form, FormLabel, InputGroup, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useApi } from "../../../../api";
import { ErrorResponseDialog } from "../../../../components/ErrorResponseDialog";
import { IBid, ICargo, INftAsset } from "../../../../interfaces";

interface NftDetailBidModalProps {
  asset: INftAsset;
  bidInfo: IBid;
  onClose: () => void;
}
export const NftDetailBidModal = ({ asset, bidInfo, onClose }: NftDetailBidModalProps) => {
  const { t } = useTranslation();
  const [price, setPrice] = useState('');
  const [processing, setProcessing] = useState(false);
  
  const projectCode = 'NFT';
  const api = useApi(projectCode);

  const handleClose = () => {
    onClose()
  };
  return (
    <>
      <Modal
        show={true}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <div style={{width: '24px'}}></div>
          <Modal.Title className="mx-auto">競標</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-gray-500 p-4 px-md-5">
          <div className="fw-bolder h5 text-center">{asset.name}</div>
          <div className="mt-3">結標日期：2022-11-11 08:00:00</div>
          <div className="text-danger">最高出價：$10.000</div>
          <Form.Group className="mt-4">
            <FormLabel>出價金額</FormLabel>
            <InputGroup>
              <Form.Control
                type="number"
                value={price}
                onChange={(e) => {
                  e.preventDefault();
                  setPrice(e.target.value)
                }}
              />
            </InputGroup>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="py-3 px-4">
          <Button disabled={processing} onClick={() => {
            if (!bidInfo) return;
            setProcessing(true);
            api.makeNftBidding(asset.nftId, bidInfo.idBid, Number(price), (cargo: ICargo) => {
              setProcessing(false);
              if (cargo.returnCode === '000000') {
                handleClose();
              } else {
                ErrorResponseDialog(cargo, t, projectCode)
              }
            })
          }}>投標</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}